export default __webpack_public_path__ + "static/media/home.905ac2f0.webp";